import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<title>Close</title>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeWidth={1.5}
			d="m16.85 6.95-9.9 9.9M6.95 6.95l9.9 9.9"
		/>
	</svg>
);
export { SvgComponent as Close24 };
